<template>
	<el-dialog
		title="计提折旧"
		:visible.sync="dialogVisible"
		width="30%"
		top="10vh"
		:close-on-click-modal="false"
		:before-close="handleClose"
		custom-class="depreciation-dialog">
		<div class="msg">资产编号：{{ data.assetNo }}</div>
		<div class="msg">资产名称：{{ data.assetName }}</div>
		<div class="msg">月折旧额：¥{{ data.monthlyDepreciation }}</div>
		<el-form ref="form" :model="form" :rules="rules" label-position="top" size="mini">
			<el-row :gutter="20">
				<!-- 计提月份 -->
				<el-col :span="24">
					<el-form-item label="计提月份" prop="depreciationMonth">
						<el-select
							v-model="form.depreciationMonth"
							size="small"
							placeholder="请选择"
							style="width: 100%"
						>
							<el-option
								v-for="month in monthOptions"
								:key="month.value"
								:label="month.label"
								:value="month.value"
							/>
						</el-select>
					</el-form-item>
				</el-col>

				<!-- 计提说明 -->
				<el-col :span="24">
					<el-form-item label="计提说明" prop="description">
						<el-input
							type="textarea"
							v-model="form.description"
							size="small"
							placeholder="请输入计提说明"
							:rows="4"
						/>
					</el-form-item>
				</el-col>

				<!-- 上传凭证 -->
				<el-col :span="24">
					<el-form-item label="上传凭证">
						<el-upload
							class="upload-demo"
							action="/api/file/upload"
							:on-success="handleUploadSuccess"
							:on-error="handleUploadError"
							:file-list="fileList"
							:limit="1"
							accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
						>
							<el-button size="small" type="primary">上传财务记账凭证</el-button>
							<div slot="tip" class="el-upload__tip">
								请上传PDF、Word或图片格式的文件
							</div>
						</el-upload>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>

		<!-- 按钮 -->
		<span slot="footer">
			<el-button @click="handleClose">取 消</el-button>
			<el-button type="primary" @click="handleSubmit">确 定</el-button>
		</span>
	</el-dialog>
</template>

<script>
	import { saveDepreciationRecord } from '@/api/asset/assetLedgerApi';
	export default {
		name: 'AssetDepreciationDialog',
		props: {
			dialogVisible: Boolean,
			data: {
				type: Object,
				default: () => ({}),
			},
		},
		watch: {
			dialogVisible(val) {
				if (val) {
					this.$nextTick(() => {
						this.$refs.form && this.$refs.form.resetFields();
						this.fileList = [];
						this.form.voucherUrl = '';
					});
				}
			},
		},
		data() {
			// 生成最近12个月的选项
			const monthOptions = [];
			const now = new Date();
			for (let i = 0; i < 12; i++) {
				const date = new Date(now.getFullYear(), now.getMonth() - i, 1);
				const year = date.getFullYear();
				const month = String(date.getMonth() + 1).padStart(2, '0');
				monthOptions.push({
					label: `${year}-${month}`,
					value: `${year}-${month}`,
				});
			}

			return {
				form: {
					description: '',
					depreciationMonth: '',
					voucherUrl: '',
					assetId: '',
				},
				rules: {
					depreciationMonth: [
						{ required: true, message: '请选择计提月份', trigger: 'change' },
					],
				},
				fileList: [],
				monthOptions,
			};
		},
		methods: {
			handleClose() {
				this.$emit('update:dialogVisible', false);
			},
			handleUploadSuccess(response, file, fileList) {
				if (response.code === 0) {
					this.form.voucherUrl = response.data;
					this.$message.success('文件上传成功');
				} else {
					this.$message.error('文件上传失败');
				}
			},
			handleUploadError(err, file, fileList) {
				this.$message.error('文件上传失败');
			},
			handleSubmit() {
				this.$refs.form.validate(valid => {
					if (!valid) return;
					const record = {
						assetId: this.data.id,
						depreciationMonth: this.form.depreciationMonth,
						description: this.form.description,
						depreciationAmount: this.data.monthlyDepreciation,
						depreciationDate: new Date().toISOString().split('T')[0],
						type: '手动计提',
						voucherPath: this.form.voucherUrl
					};
					saveDepreciationRecord(record)
						.then(() => {
							this.$message.success('计提折旧成功');
							this.$emit('updateSuccess');
							this.handleClose();
						})
						.catch(err => {
							console.log(err);
							this.$message.error('计提折旧失败');
						});
				});
			},
		},
	};
</script>

<style scoped lang="scss">
	:deep(.depreciation-dialog) {
		.el-dialog__body {
			max-height: 60vh; // 控制最大高度
			overflow-y: auto; // 开启纵向滚动
		}
		/* 整体滚动条宽度 */
		.el-dialog__body::-webkit-scrollbar {
			width: 6px;
		}

		/* 滚动条轨道 */
		.el-dialog__body::-webkit-scrollbar-track {
			background: #f5f5f5;
			border-radius: 3px;
		}

		/* 滑块 */
		.el-dialog__body::-webkit-scrollbar-thumb {
			background: #bbbbbb;
			border-radius: 3px;
			transition: all 0.3s;
		}

		/* hover 时 */
		.el-dialog__body::-webkit-scrollbar-thumb:hover {
			background: #a8a8a8;
		}
	}

	.msg {
		color: #333;
		margin-bottom: 5px;
	}
</style>
